import { Helmet } from "react-helmet-async";

const Footer = () => {
  return (
    <>
      {/* SEO Metadata */}
      <Helmet>
        <title>Dr. Srikanth UroCare Clinic - Best Urology Care in Bengaluru</title>
        <meta name="keywords" content="urology, urologist, Bengaluru, kidney care, urological treatment, Dr. Srikanth" />
        <meta name="description" content="Dr. Srikanth UroCare Clinic provides expert urological care in Bengaluru. Book an appointment today for personalized treatment." />
        
        {/* Open Graph Meta Tags for Social Media */}
        <meta property="og:title" content="Dr. Srikanth UroCare Clinic - Excellence in Urological Care" />
        <meta property="og:description" content="Providing top-quality urological treatments in Bengaluru. Book an appointment today." />
        <meta property="og:image" content="https://drsrikanthurologist.com/feedback-thumbnail.webp" />
        <meta property="og:url" content="https://drsrikanthurologist.com" />
        <meta property="og:type" content="website" />

        {/* Local Business Schema Markup for Better SEO */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "MedicalClinic",
            "name": "Dr. Srikanth UroCare Clinic",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "476, 6th Main, 8th Cross Rd, Mico Layout, BTM 2nd Stage",
              "addressLocality": "Bengaluru",
              "postalCode": "560076",
              "addressCountry": "IN"
            },
            "telephone": "+916366017702",
            "email": "drsrikanthuro@gmail.com",
            "url": "https://drsrikanthurologist.com",
            "description": "Providing expert urological care and kidney treatments in Bengaluru.",
            "image": "https://drsrikanthurologist.com/clinic-image.jpg"
          })}
        </script>
      </Helmet>

      {/* Footer Section */}
      <footer className="bg-black text-white py-6">
        <div className="container mx-auto px-6 flex flex-col md:flex-row justify-around items-center text-center md:text-left space-y-6 md:space-y-0">
          
          {/* Location Section */}
          <div>
            <h3 className="text-lg font-semibold">Dr. Srikanth UroCare Clinic</h3>
            <p className="mt-2 flex items-center">
              <span className="mr-2">📍</span> 
              476, 6th Main, 8th Cross Rd, Mico Layout, BTM 2nd Stage, Bengaluru 560076
            </p>
            <p className="text-gray-400">"Where Excellence Meets Urological Care"</p>
          </div>

          {/* Contact Section */}
          <div>
            <h3 className="text-lg font-semibold">Contact Us</h3>
            <p className="mt-2 flex items-center">
              <span className="mr-2">📞</span> 
              Call <a href="tel:+916366017702" className="underline hover:text-gray-300">+91 6366017702</a>
            </p>
            <p className="mt-2 flex items-center">
              <span className="mr-2">📧</span> 
              <a href="mailto:drsrikanthuro@gmail.com" className="underline hover:text-gray-300">drsrikanthuro@gmail.com</a>
            </p>
          </div>
        </div>

        {/* Copyright Section */}
        <div className="mt-6 border-t border-gray-700 text-center py-4 text-gray-400">
          <p>© 2025 Dr. Srikanth UroCare Clinic. All rights reserved.</p>
        </div>

        {/* Floating Call Button */}
        <div className="fixed bottom-6 right-6 flex flex-col gap-4">
        {/* Call Button */}
        <a
          href="tel:+919876543210" // <-- Replace with real phone number
          className="inline-flex items-center justify-center gap-2 bg-green-600 hover:bg-green-700 text-white font-semibold py-3 px-6 rounded-lg shadow-md transition duration-300 text-lg"
        >
          📞
        </a>
              
        {/* Appointment Button */}
        <a
          href="https://www.apollo247.com/doctors/dr-srikanth-1939d895-2d16-43c1-bc57-bce6ef4b3106"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-6 rounded-lg shadow-md transition duration-300 text-lg"
        >
          📅
        </a>
      </div>
        
      </footer>
    </>
  );
};

export default Footer;
